import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import * as React from 'react';
const SvgStatusCheck = ({
  accessibilityText,
  forwardedRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  width: 24,
  height: 24,
  "aria-hidden": accessibilityText ? undefined : true,
  "aria-label": accessibilityText,
  fill: "currentColor",
  focusable: false,
  ref: forwardedRef,
  role: accessibilityText ? 'img' : undefined
}, props), /*#__PURE__*/React.createElement("path", {
  d: "m10.42 15.76-3.41-3.41 1.34-1.34L11 13.66l5.65-5.65 1.34 1.34-6.41 6.41a.82.82 0 0 1-1.16 0M12 3.9c-4.47 0-8.1 3.63-8.1 8.1s3.63 8.1 8.1 8.1 8.1-3.63 8.1-8.1-3.63-8.1-8.1-8.1M12 2c5.52 0 10 4.48 10 10s-4.48 10-10 10S2 17.52 2 12 6.48 2 12 2"
}));
export default SvgStatusCheck;